<template>
    <div>
    	<div class="services-steps">
            <div class="grid-2_xs-1">
                <div class="col">
                    <div class="services-steps__nav">
                        <div class="services-steps__items">
                            <span class="services-steps__nav-marker"></span>
                            <a class="services-steps__item" v-bind:href="'#' + translations['1'].slug" v-on:click.prevent="switchStep(1)" v-bind:class="[ activeStep === 1 ? 'services-steps__item--active' : '' ]">{{ translations['1'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['2'].slug"  v-on:click.prevent="switchStep(2)" v-bind:class="[ activeStep === 2 ? 'services-steps__item--active' : '' ]">{{ translations['2'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['3'].slug"  v-on:click.prevent="switchStep(3)" v-bind:class="[ activeStep === 3 ? 'services-steps__item--active' : '' ]">{{ translations['3'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['4'].slug"  v-on:click.prevent="switchStep(4)" v-bind:class="[ activeStep === 4 ? 'services-steps__item--active' : '' ]">{{ translations['4'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['5'].slug"  v-on:click.prevent="switchStep(5)" v-bind:class="[ activeStep === 5 ? 'services-steps__item--active' : '' ]">{{ translations['5'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['6'].slug"  v-on:click.prevent="switchStep(6)" v-bind:class="[ activeStep === 6 ? 'services-steps__item--active' : '' ]">{{ translations['6'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['7'].slug"  v-on:click.prevent="switchStep(7)" v-bind:class="[ activeStep === 7 ? 'services-steps__item--active' : '' ]">{{ translations['7'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['8'].slug"  v-on:click.prevent="switchStep(8)" v-bind:class="[ activeStep === 8 ? 'services-steps__item--active' : '' ]">{{ translations['8'].title }}</a>
                            <a class="services-steps__item" v-bind:href="'#' + translations['9'].slug"  v-on:click.prevent="switchStep(9)" v-bind:class="[ activeStep === 9 ? 'services-steps__item--active' : '' ]">{{ translations['9'].title }}</a>
                        </div>
                    </div>
                </div>
                <div class="col">
                	<div class="services-steps__content">
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 1">
                    			<img class="services-steps__illust" src="/images/services/planification.svg" v-bind:alt="translations['1'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['1'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['1'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['1'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 2">
                    			<img class="services-steps__illust" src="/images/services/solutions.svg" v-bind:alt="translations['2'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['2'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['2'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['2'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 3">
                    			<img class="services-steps__illust" src="/images/services/innovation.svg" v-bind:alt="translations['3'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['3'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['3'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['3'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 4">
                    			<img class="services-steps__illust" src="/images/services/conception.svg" v-bind:alt="translations['4'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['4'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['4'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['4'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 5">
                    			<img class="services-steps__illust" src="/images/services/production.svg" v-bind:alt="translations['5'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['5'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['5'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['5'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 6">
                    			<img class="services-steps__illust" src="/images/services/implantation.svg" v-bind:alt="translations['6'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['6'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['6'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['6'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 7">
                    			<img class="services-steps__illust" src="/images/services/verification.svg" v-bind:alt="translations['7'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['7'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['7'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['7'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 8">
                    			<img class="services-steps__illust" src="/images/services/formation.svg" v-bind:alt="translations['8'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['8'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['8'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['8'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                        <transition name="step-fade">
                    		<div class="services-steps__step-content" v-show="activeStep === 9">
                    			<img class="services-steps__illust" src="/images/services/continuation.svg" v-bind:alt="translations['9'].title">
                                <ul class="services-steps__desc">
                                    <li class="services-steps__desc-item">{{ translations['9'].desc['1'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['9'].desc['2'] }}</li>
                                    <li class="services-steps__desc-item">{{ translations['9'].desc['3'] }}</li>
                                </ul>
                    		</div>
                        </transition>
                	</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
        props: {
            translations: Object,
        },
		data() {
			return {
				activeStep: 1,
			}
		},
		methods: {
			switchStep(step) {
				this.activeStep = step;
			}
		},
		mounted() {
			this.switchStep(1);
		}
	}
</script>